import { useState, useEffect } from "react";
import { useRequest } from "ahooks";
import { Table, Space, Input, Select, DatePicker } from "antd";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
  announcement as announcementService,
  setting as settingService,
} from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import styles from "./index.module.less";

function Column0Table({ column }) {
  const [publication, setPublication] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const auth = useAuthContext();
  const { data: publications = { results: [] }, loading: publicationLoading } =
    useRequest(() => settingService.listPublication({}, auth.token), {
      ready: !!auth.token,
      refreshDeps: [auth.token],
    });
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return announcementService.listMyReceiveAnnouncement(params, token);
    },
    {
      manual: true,
      throttleWait: 600,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          publication,
          search: keyword,
          page,
          page_size: pageSize,
          start_date: startDate,
          end_date: endDate,
          column,
        },
        auth.token
      );
    }
  }, [
    run,
    auth,
    keyword,
    page,
    pageSize,
    publication,
    startDate,
    endDate,
    column,
  ]);

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 50,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "刊物",
      width: 120,
      key: "publication",
      render: (record) => {
        return record.publication?.name;
      },
    },
    {
      title: "标题",
      dataIndex: "title",
      render: (text, record) => (
        <Link to={`/workshop/announce/detail/${record.id}`} target="_blank">{text}</Link>
      ),
    },
    {
      title: "日期",
      dataIndex: "published_at",
      width: 120,
      render: (text, record) => moment(text).format("YYYY-MM-DD"),
    },
  ];
  return (
    <div className={styles.draftAnnouncement}>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              刊物：
              <Select
                loading={publicationLoading}
                style={{ width: 120 }}
                onChange={(value) => setPublication(value)}
                allowClear
              >
                {publications.results.map((p) => (
                  <Select.Option key={`publication-${p.id}`} value={p.id}>
                    {p.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div>
              日期：
              <DatePicker.RangePicker
                disabledDate={(current) => current.isAfter(moment())}
                onChange={(value) => {
                  setStartDate(value[0].format("YYYY-MM-DD"));
                  setEndDate(value[1].format("YYYY-MM-DD"));
                }}
              />
            </div>
            <div>
              标题：
              <Input
                prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                style={{ width: 220 }}
                placeholder="搜索内容"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
          </Space>
        </div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </div>
  );
}

export default Column0Table;
